module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/join-us-bc9dbf63a1b776c92bf51dd4cd487f14.png";